import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const getUserType = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/search-user-type",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addUserType = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user-type",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateUserType = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user-type",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// User Role

export const getUserRole = (data) => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/role",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addUserRole = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/role",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateUserRole = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/role",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// Bank

export const getBank = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/bank",
    headers: getHeaders(),
  });
};

export const addBank = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/bank",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBank = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/bank",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// CAUser

export const getCAUser = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/causer-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addCAUser = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/causer",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateCAUser = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/causer",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// Company

export const getCompany = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/company-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addCompany = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/company",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateCompany = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/company",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// Banker

export const getBanker = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/banker-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addBanker = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/banker",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBanker = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/banker",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// UserAPi

export const getUser = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/search-user",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addUser = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateUser = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getUserStatus = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user-status",
    headers: getHeaders(),
  });
};


export const getUserTypeCategory = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user-type-category",
    headers: getHeaders(),
  });
};


// Product

export const getProduct = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/product-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addProduct = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/product",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateProduct = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/product",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// Product Level

export const getProductLevel = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/product-level-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addProductLevel = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/product-level",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateProductLevel = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/product-level",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// Business Partner

export const getBusinessPartner = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/business-partner-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addBusinessPartner = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/business-partner",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBusinessPartner = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/business-partner",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBusinessPartnerProfile = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/business-partner-profile",
    headers: getHeaders(),
  });
};

export const getBusinessPartnerStatus = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/business-partner-status",
    headers: getHeaders(),
  });
};


// IVR Extension

export const getIVRExtension = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/ivr-extension-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addIVRExtension = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/ivr-extension",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateIVRExtension = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/ivr-extension",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// IVR Extension User

export const getIVRExtensionUser = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/ivr-extension-user-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addIVRExtensionUser = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/ivr-extension-user",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateIVRExtensionUser = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/ivr-extension-user",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// Branch

export const getBranch = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/branch/search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addBranch = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/branch",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBranch = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/branch",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// bank-account


export const getBankAccount = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/bank-account",
    headers: getHeaders(),
  });
};

export const addBankAccount = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/bank-account",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBankAccount= (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/bank-account",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// Process Fee

export const getProcessFee = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/search-process-fee",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addProcessFee = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/process-fee",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateProcessFee = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/process-fee",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};



// State Cities

export const getStateCities = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/city-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addStateCities = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/city",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateStateCities = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/city",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStateWiseCities = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/state-wise-city",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addBulkCities = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/bulk-city",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};



// Loan File

export const getLoanFile = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/loan-file-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addLoanFile = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/loan-file",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateLoanFile = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/loan-file",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getLoanFileStatus = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/loan-file-status",
    headers: getHeaders(),
  });
};


export const getPreferredLanguage = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/preferred-language",
    headers: getHeaders(),
  });
};


export const getPinCodeData = (pinCode, apiKey) => {
  return axios({
    method: "GET",
    url: `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${pinCode}|country:IN&key=${apiKey}`,
    // headers: getHeaders(),
  });
};


// category-level

export const getCategoryLevel = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/category-level-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addCategoryLevel = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/category-level",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateCategoryLevel = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/category-level",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};